<template>
  <div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-light ">
    <!-- BEGIN: Aside Menu -->
    <div
        id="m_ver_menu"
        class="m-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light"
        style="position: relative;">
      <client></client>
      <navigation></navigation>
    </div>
    <!-- END: Aside Menu -->
  </div>
</template>

<script>
  import Client from "@/components/sidebar/Client";
  import Navigation from "@/components/sidebar/Navigation";

  export default {
    name: "Sidebar",
    components: {Navigation, Client}
  }
</script>

<style scoped>

</style>
